import Vue from 'vue'

Vue.filter('money', (val) => {
  if (!val) {
    return 0
  }

  val = String(val)
  val = val.replace(/,/g, '')
  val = Number(val)
  val = val.toLocaleString()
  val = val.toString()

  return val
})
